import { Button } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: var(--color-background, #fff);
  border-radius: 8px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: var(--spacing-lg, 16px) var(--spacing-xl, 24px);
  border-bottom: 1px solid var(--color-border, #c5c6ca);
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 900;
  line-height: 1.75rem;
  color: var(--color-gray-950, #19191b);
`;

export const CloseButton = styled(Button)`
  && {
    flex-shrink: 0;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background: var(--color-gray-50, #f6f6f7);
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--spacing-sm, 8px);
  flex-shrink: 0;
  padding: var(--spacing-lg, 16px) var(--spacing-xl, 24px);
  border-top: 1px solid var(--color-border, #c5c6ca);
`;
